<app-header [label]="page_name | plural"></app-header>
<div class="flex bg-white gap-4 items-center justify-between p-4 border-b border-gray-300">
  <app-search-input #searchbar (fetch_new_list)="get_list($event)"></app-search-input>
  <div class="flex gap-2">
    <app-button color="bg-secondary text-[#310000]" [label]="page_name" icon="bx bx-plus"
      (click)="open_form_modal()"></app-button>
    <app-button color="bg-secondary text-[#310000]" [label]="`Add Bulk ${page_name | plural}`" icon="bx bx-plus"
      (click)="bulk_modal.open()"></app-button>
  </div>
</div>
<app-ag-grid-list [list]="items" [colDefs]="columns" [itemName]="page_name" (fetch_new_list)="get_list($event)"
  (bulkDelete)="bulk_delete($event)"></app-ag-grid-list>
<app-confirmation-popup #confirmation_disabled_modal [enable_icon]="true" confirmColor="bg-[#FA2912] text-[#FFFFFF]"
  [is_mandatory]="true" (confirm_modal_clicked)="update_country(selected_ids.is_active)"
  (close_modal_clicked)="confirmation_delete_modal.close()">
  Are you sure you want to {{selected_ids.is_active == true? "Disable" :"Enable"}} Division
</app-confirmation-popup>
<app-confirmation-popup #confirmation_delete_modal [delete_icon]="true" confirmColor="bg-[#FA2912] text-[#FFFFFF]"
  [is_mandatory]="true" (confirm_modal_clicked)="delete()" (close_modal_clicked)="confirmation_delete_modal.close()">
  Are you sure you want to Delete Division.
</app-confirmation-popup>
<app-modal #form_modal [label]="`${selected_ids.id ? 'Update' : 'Add'} ${page_name}`">
  <form [formGroup]="form">
    <div class="py-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
      <app-select-input label="Country" class="w-full" [is_required]="true" formControlName="country_id"
        [options]="dds.dropdown_list?.country_list"></app-select-input>
      <app-select-input label="State" class="w-full" [is_required]="true" formControlName="state_id"
        [options]="dds.dropdown_list?.state_list | filterByKeyAndValue : 'country.id' :form.get('country_id')?.value"></app-select-input>
      <app-text-input [is_required]="true" type="text" class="w-full" [label]="page_name + ' Name'"
        formControlName="name"></app-text-input>
      <app-text-input [is_required]="true" class="w-full" [label]="page_name + ' Code'"
        formControlName="code"></app-text-input>
    </div>
    <div class="flex justify-end items-center gap-2 mt-2">
      <app-button color="border-primary text-primary" label="Cancel" type="button"
        (click)="close_form_modal()"></app-button>
      <app-button color="bg-secondary text-black" [label]="selected_ids.id ? 'Update' :'Add'" type="button"
        [disabled]="isSubmitting" [submit]="submit.bind(this)"></app-button>
    </div>
  </form>
</app-modal>
<app-modal #bulk_modal label="Bulk Upload {{page_name | plural}}" sub_label="Add {{ page_name }} in Bulk">
  <app-bulk-upload [title]="page_name" [cancel]="bulk_modal" [accepted_type]="['.csv']" [max_file_sizeMB]="5"
    [bulk_columns]="bulk_columns" (submit)="bulk_upload($event.data,$event.spinner)"></app-bulk-upload>
</app-modal>
<app-modal #view_modal [label]="'View '+ page_name" width="md" (close_modal_clicked)="view_modal.close()">
  <div class="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Country Name</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.State?.country?.name }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">State Name</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.State?.name || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">{{page_name}} Name</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.name || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">{{page_name}} Code</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.code || '—' }}</p>
    </div>
  </div>
</app-modal>